import {
  Box,
  Button,
  Flex,
  HStack,
  IconButton,
  useColorModeValue as mode,
  VisuallyHidden,
  useMediaQuery,
} from "@chakra-ui/react";
import {
  Center,
  Stack,
  Text,
  Heading,
  Wrap,
} from "@chakra-ui/layout";
import * as React from "react";
import { signIn, signOut, useSession } from "next-auth/react";
import NextLink from "next/link";
import { AccountSwitcher } from "components/account";
import { NavLink } from "./nav-link";
import { NavButton } from "./nav-button";
import { useRouter } from "next/dist/client/router";
import { getAccount, updateUser, getAuthUrl, selectAccount, logout } from "utils/sessionHelper";

import { Logo } from "components/logo";
// import { MobileNav } from "./mobile-nav";
import Link from "next/link";

import { FiLogOut } from "react-icons/fi";

const baseUrl =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ? "http://localhost:3003"
    : "https://app.tweethunter.io";

export const Navbar = ({disableMenu=false, disableName=false, svgLogo=false}) => {
  const { data: session, status } = useSession() ?? {}
  const loading = status === "loading"

  const router = useRouter();
  const [isTooSmall] = useMediaQuery("(max-width: 900px)");

  return (
    <Box>
      <Flex p={5} pl={7} pt={3} pr={0} justifyContent="space-between">
        <Center css={{}}>
          {disableMenu ? (
            <Box>
              <VisuallyHidden>Taplio</VisuallyHidden>
              <Logo
                h="8"
                // svgLogo={svgLogo}
              />
            </Box>
          ) : (
              <Box as="a" href="/dashboard" rel="home">
              <VisuallyHidden>Taplio</VisuallyHidden>
              <Logo
                h="8"
                // svgLogo={svgLogo}
              />
            </Box>
          )}
        </Center>
        {session?.expires && session?.user ? (
          <Stack isInline alignItems="center" spacing={5}>
            {!isTooSmall && !disableMenu && (
              <Stack isInline alignItems="center" spacing={5}>
                <NextLink href="/auto">
                  {/* <NavButton isSelected={router.pathname.includes("application")} text="Search"/> */}
                  <Button
                    height="32px"
                    width="90px"
                    // mr={3}
                    bg={
                      router.pathname.includes("auto")
                        ? mode("gray.600", "gray.400")
                        : mode("gray.100", "gray.600")
                    }
                    color={
                      router.pathname.includes("auto")
                        ? mode("white", "#1E1E1E")
                        : mode("#1E1E1E", "white")
                    }
                    _hover={{ bg: mode("gray.300", "gray.500") }}
                    variant="ghost"
                  >
                    Auto
                  </Button>
                </NextLink>
                <NextLink href="/search">
                  {/* <NavButton isSelected={router.pathname.includes("application")} text="Search"/> */}
                  <Button
                    height="32px"
                    width="90px"
                    // mr={3}
                    bg={
                      router.pathname.includes("search")
                        ? mode("gray.600", "gray.400")
                        : mode("gray.100", "gray.600")
                    }
                    color={
                      router.pathname.includes("search")
                        ? mode("white", "#1E1E1E")
                        : mode("#1E1E1E", "white")
                    }
                    _hover={{ bg: mode("gray.300", "gray.500") }}
                    variant="ghost"
                  >
                    Search
                  </Button>
                </NextLink>
                <NextLink href="/collections">
                  <Button
                    height="32px"
                    mr={5}
                    bg={
                      router.pathname.includes("collections")
                        ? mode("gray.600", "gray.400")
                        : mode("gray.100", "gray.600")
                    }
                    color={
                      router.pathname.includes("collections")
                        ? mode("white", "#1E1E1E")
                        : mode("#1E1E1E", "white")
                    }
                    _hover={{ bg: mode("gray.300", "gray.500") }}
                    variant="ghost"
                  >
                    My Collections
                  </Button>
                </NextLink>
                {
                  // session?.user?.data?.isBeta && (
                  session?.user?.uid && (
                    <NextLink href="/variations">
                      <Button
                        height="32px"
                        mr={5}
                        bg={
                          router.pathname.includes("variations")
                            ? mode("gray.600", "gray.400")
                            : mode("gray.100", "gray.600")
                        }
                        color={
                          router.pathname.includes("variations")
                            ? mode("white", "#1E1E1E")
                            : mode("#1E1E1E", "white")
                        }
                        _hover={{ bg: mode("gray.300", "gray.500") }}
                        variant="ghost"
                      >
                        My Variations
                      </Button>
                    </NextLink>
                  )
                }
              </Stack>
            )}
            <Box>
              <Button
                _hover={{ bg: "gray.600" }}
                variant="ghost"
                onClick={(e) => {
                  logout();
                }}
              >
                log out
              </Button>
            </Box>
            <Box>
              {!loading && session?.user && (
                <AccountSwitcher
                  disableMenu={disableMenu}
                  disableName={true}
                  user={session?.user}
                />
              )}
            </Box>
          </Stack>
        ) : (
          <HStack spacing="8" display={{ base: "none", md: "flex" }}>
            <Button
              variant="ghost"
              onClick={() =>
                signIn("twitter", {
                  callbackUrl: baseUrl + "/dashboard",
                })
              }
            >
              Log in{" "}
            </Button>
          </HStack>
        )}
      </Flex>
    </Box>
  );
};
